import React, { useEffect, useState } from 'react';

import { Popover } from '@shared/components';

import ProductActivationInfo from '../productActivationInfo/ProductActivationInfo';
import { IFieldInfoPopoverProps } from '@shared/types';
import { TOPICS_CONSTANTS, subscribe } from '@shared/utils';
import styles from './FieldInfoPopover.module.scss';

const FieldInfoPopover = ({
	id,
	infoList,
	children,
}: IFieldInfoPopoverProps) => {
	const [shouldShowPopover, setShouldShowPopover] = useState(false);
	const isEmpty = infoList?.length === 0;
	const getPopupContainer = (triggerNode: HTMLElement) => {
		return triggerNode.parentNode as HTMLElement;
	};

	useEffect(() => {
		subscribe(TOPICS_CONSTANTS.SELECTED_FIELDS, (objId) => {
			setShouldShowPopover(id === objId);
		});
	}, []);

	return (
		<Popover
			content={<ProductActivationInfo infoList={infoList} />}
			trigger="click"
			open={!isEmpty && shouldShowPopover}
			getPopupContainer={getPopupContainer}
			overlayClassName={styles.activationInfoOverlay}
			placement="right"
		>
			{children}
		</Popover>
	);
};

export default FieldInfoPopover;
